export default __webpack_public_path__ + "static/media/kyowa.189b3109.png";